import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getAvailableConditions } from "@/types/filterEnums";

interface ConditionDropdownProps {
  condition: string;
  onConditionChange: (newCondition: string) => void;
  isConsolidated?: boolean;
  values?: (string | number)[];
}

export const ConditionDropdown: React.FC<ConditionDropdownProps> = ({
  condition,
  onConditionChange,
  isConsolidated = false,
  values,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConditionChange = (newCondition: string) => {
    onConditionChange(newCondition);
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <button
          className="hover:text-secondary-n-200 text-secondary-n-400 flex items-center gap-1"
          onClick={(e) => e.stopPropagation()}
        >
          <span>{condition}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-32">
        {getAvailableConditions(values).map((availableCondition) => (
          <DropdownMenuItem
            key={availableCondition}
            onClick={() => handleConditionChange(availableCondition)}
          >
            {availableCondition}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
